import { IconLoginLogo } from "@/assets/icons/IconLoginLogo";
import { RecoverSuccessForm } from "@/features/auth/components/RecoverSuccessForm";
import { AppRoutes } from "@/routes/config";
import { black } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { Navigate, useLocation } from "react-router-dom";

export const RecoverSuccessPage: FC = () => {
  const location = useLocation();
  const email = (location.state as { email?: string } | null)?.email;

  if (!email) {
    return <Navigate to={AppRoutes.pageNotFound} replace />;
  }

  return (
    <Stack gap="80px" alignItems="center" width="100%">
      <Stack gap={1}>
        <IconLoginLogo />
        <Stack alignItems="center" width={240} paddingY={1} bgcolor={black[30]}>
          <Typography variant="sub16Bold" color="white">
            center│システム管理
          </Typography>
        </Stack>
      </Stack>
      <RecoverSuccessForm />
    </Stack>
  );
};
